import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/mobile',
    component: () => import('@/views/main/index.vue'),
    children: [
      {
        path: '/mobile',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/index.vue'),
      },
      {
        path: '/business',
        name: 'business',
        component: () => import('@/views/business/index.vue'),
      },
      {
        path: '/news',
        name: 'news',
        component: () => import('@/views/news/index.vue'),
      },
      {
        path: '/join',
        name: 'join',
        component: () => import('@/views/join/index.vue'),
      },
      {
        path: '/news/newsDetail/:newsId',
        name: 'newsDetail',
        component: () => import('@/views/newsDetail/index.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/index.html',
    redirect: '/home',
  },
]

export default routes
